import React from "react";
import { ContentSection, ButtonRenderProps } from "sprint-common-web";

import { LanguagesDataProvider } from "../../../../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import {
    ensureAudioFileRecordDetails,
    isFileRecordDetailsEditable
} from "../../../../../../common/file-record-details/FileRecordDetails";
import { AudioFileRecordLanguagesView } from "../../../../../../common/file-record-details/languages/AudioFileRecordLanguagesView";
import { useFileRecordDetailsState } from "../../../../hooks/useFileRecordDetailsState";
import {
    EditAudioSoundtrackButtonAside,
    EditAudioSoundtrackButtonAsideProps
} from "../edit/audio-soundtrack/EditSoundtrackButtonAside";

interface AudioFileRecordLanguagesSectionProps {
    height: number;
}

export const AudioFileRecordLanguagesSection = ({ height }: AudioFileRecordLanguagesSectionProps): JSX.Element => {
    const { fileRecordDetails, isLoading } = useFileRecordDetailsState();

    ensureAudioFileRecordDetails(fileRecordDetails);

    const editSoundtrackButtonAside: ButtonRenderProps<EditAudioSoundtrackButtonAsideProps> = {
        isLabeled: true,
        isDisabled: !isFileRecordDetailsEditable(fileRecordDetails),
        render: EditAudioSoundtrackButtonAside
    };

    const soundtrackButtons = [editSoundtrackButtonAside];

    return (
        <LanguagesDataProvider>
            <ContentSection
                header="Languages"
                isLoading={isLoading}
                testId="languages-content-section"
                buttons={soundtrackButtons}
            >
                <AudioFileRecordLanguagesView fileRecordDetails={fileRecordDetails} height={height} />
            </ContentSection>
        </LanguagesDataProvider>
    );
};
